module.exports = __webpack_public_path__ + "static/media/roses.b92f7b01.jfif";